<div #fromWhereConnectionIsComingModal class="modal fade" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md modal-copy">
    <div class="modal-content no-border border-radius-0 mw-85">
      <div class="modal-header text-uppercase font-size-16">
        <div class="modal-title">
          <ng-container i18n="@@app.outgoing_wiring_of_upstream_device">Outgoing wiring of upstream device</ng-container>
        </div>
        <button type="button" (click)="closeModal()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" class="color-black">&times;</span>
        </button>
      </div>
      <div class="modal-body mx-2 px-0">
        <div>
          <app-select-current-source-modal [selectedOption]="selectedOption" (optionSelected)="selectOption($event)">
          </app-select-current-source-modal>
        </div>
      </div>

      <div class="modal-footer pt-0 no-border">
        <button type="button" (click)="closeModal()"
                class="btn btn-light btn-lg text-uppercase border-rounded font-weight-normal mx-2"
                i18n="@@app.cancel">Cancel</button>
        <button appDisableMultipleClick
                type="button"
                class="btn btn-primary btn-lg text-uppercase border-rounded mx-2 font-weight-normal" i18n="@@app.ok"
                (click)="onConfirm()">Ok</button>
      </div>
    </div>
  </div>
</div>
